import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import {
  ProductVendorType,
  ProductVendorPaginationType,
  GetProductVendorsResponseType,
  ProductDetailType,
} from '../../services/productVendor'

interface InitialStateType {
  isLoading: boolean
  productVendors: {
    pagination: ProductVendorPaginationType
    data: ProductVendorType[]
  }
  productDetails: ProductDetailType
  picSourcingList: { id: number; full_name: string }[]
  productVendorDetails: ProductVendorType
}

const initialState: InitialStateType = {
  isLoading: false,
  productVendors: {
    data: [],
    pagination: {
      total_elements: 0,
      page_size: 0,
      page_index: 0,
      prev_cursor: '',
      next_cursor: '',
    },
  },
  productDetails: {} as ProductDetailType,
  picSourcingList: [],
  productVendorDetails: {} as ProductVendorType,
}

export const sliceName = 'productVendors'

export const productVendorsSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setProductVendors: (state, action: PayloadAction<GetProductVendorsResponseType>) => {
      state.productVendors = action.payload
    },
    setProductDetails: (state, action: PayloadAction<ProductDetailType>) => {
      state.productDetails = action.payload
    },
    setPicSourcingList: (state, action: PayloadAction<{ id: number; full_name: string }[]>) => {
      state.picSourcingList = action.payload
    },
    setProductVendorDetails: (state, action: PayloadAction<ProductVendorType>) => {
      state.productVendorDetails = action.payload
    },
  },
})

export const {
  setLoading,
  setProductVendors,
  setProductDetails,
  setPicSourcingList,
  setProductVendorDetails,
} = productVendorsSlice.actions

export default productVendorsSlice.reducer
